import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { v4 as uuidv4 } from 'uuid';

import Bs4Kartoteka from '../Bs4Kartoteka';
import Bs4Partition from './Bs4Partition'
import Bs4MainDispatch from '../Bs4MainDispatch';
import Bs4MainWindow from '../Bs4MainWindow';
import Bs4FormElement from './Bs4FormElement';
import formFieldBinding from './Bs4FormFieldBinding'
import Bs4Section from './Bs4Section';
import Bs4GenericField from './Bs4Fields/Bs4GenericField';
import Bs4FormElementDraggableList, {Bs4FormElementDraggable} from './Bs4FormElementDraggableList';

import Bs4I18N from '../Bs4I18N';
import * as Bs4Utils from '../Bs4Components/Bs4Utils'; 

import { getUxTemplate, UxAccordion, UXTEMPLATE, useStateUxTemplate } from '../Bs4Theme/Bs4UxTemplates';
import { EventEmit } from '../Bs4Components/Bs4Utils'
import { DndContext, DragOverlay, useDroppable } from '@dnd-kit/core';
import { useScrollTarget }  from '../Bs4Components/HideOnScroll'

export const TYPE_BS4_FORM = 'type_Bs4Form';

export default class Bs4Form extends Bs4FormElement {
  static MINI_LEFT_MENU = 'miniLeftMenu';
  bs4InputIdMap = new Map();
  bs4SavedStateMap = new Map();

  constructor(props, criterion) {
    super(props);
    this.criterion = Boolean(criterion);
    const bs4Kartoteka = Bs4Kartoteka.get(this.bs4KartotekaId);
    this.bs4ConstructorMode = {};
    this.bs4ConstructorMode.enabled = bs4Kartoteka.message._Komunikat.bs4ConstructorMode;
    this.eventEmit = new EventEmit();    
  }

  currentField = null;

  setMiniLeftMenu = () => {
    Bs4MainWindow.instance.setMiniLeftMenu(Boolean(this.getPageParam(Bs4Form.MINI_LEFT_MENU)));
  }

  createModel() {
    this.createForm();
  }

  defaultUxTemplate = {
    class: 189,
    name: 'Bs4Form',
    body: {                
      Form: {
        Section: {
          alignItems:         'flex-start',
          spacing:            1,
          header: {            
            typography:       'h5',
            padding:          '5px 10px 5px 10px',
          },    
          box: {
            elevation:        2,
            padding:          1,
          },          
        },
      },
    }
  };

  setUxTemplate = (id) => {
    if (!id) id = this.getPageParam(UXTEMPLATE);
    this.uxTemplate = getUxTemplate(this.defaultUxTemplate, this.props.optionType, id, this.optionId,);
  }

  getUxTemplateEditor = (uxEditor) => {

    const eds = [{ 
      label: Bs4I18N.getTT('Header', 'Header', 'Bs4Form'),
      types: TYPE_BS4_FORM,
      onReset: () => this.uxTemplate.body.Form.Section.header = JSON.parse(JSON.stringify(this.defaultUxTemplate.body.Form.Section.header)),
      Content: (props) => {
        const uxBody = this.uxTemplate.body.Form.Section;
        const type = TYPE_BS4_FORM;
        const {} = useStateUxTemplate(type);

        return (
          <Box display='flex' flexDirection='column' p={1.5}>
            <Stack direction="row" justifyContent="space-around" alignItems="center" spacing={1}>
              <uxEditor.ViewCssColor types={type} value={uxBody.header} name='color' title='Nag. text'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.header} name='backgroundColor' title='Nag. tło'/>
            </Stack>              
            <uxEditor.ViewCssTypography types={type} value={uxBody.header} name='typography'/>
            <uxEditor.ViewCssText types={type} value={uxBody.header} name='padding'/>            
          </Box>
        )
      },
    }, { 
      label: Bs4I18N.getTT('Content', 'Content', 'Bs4Form'),
      types: TYPE_BS4_FORM,
      onReset: () => {
        this.uxTemplate.body.Form.Section.box = JSON.parse(JSON.stringify(this.defaultUxTemplate.body.Form.Section.box))
        this.uxTemplate.body.Form.Section.alignItems = JSON.parse(JSON.stringify(this.defaultUxTemplate.body.Form.Section.alignItems))
      },
      Content: (props) => {
        const uxBody = this.uxTemplate.body.Form.Section;
        const type = TYPE_BS4_FORM;
        const {} = useStateUxTemplate(type);

        return (
          <Box display='flex' flexDirection='column' p={1.5}>            
            <uxEditor.ViewCssSelect types={type} value={uxBody} name='alignItems' options={['flex-start', 'flex-end', 'center', 'baseline', 'stretch']}/>
            <Stack direction="row" justifyContent="space-around" alignItems="center" spacing={1}>
              <uxEditor.ViewCssColor types={type} value={uxBody.box} name='color' title='Tekst'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.box} name='backgroundColor' title='Tło'/>
              <uxEditor.ViewCssColor types={type} value={uxBody.box} name='borderColor' title='Ramka'/>
            </Stack>                                  

            <uxEditor.ViewCssShadow types={type} value={uxBody.box} name='elevation'/>
            <uxEditor.ViewCssText types={type} value={uxBody.box} name='borderRadius'/>
            <uxEditor.ViewCssText types={type} value={uxBody.box} name='borderWidth'/>

            <uxEditor.ViewCssNumber types={type} value={uxBody.box} name='margin'/>
            <uxEditor.ViewCssText types={type} value={uxBody.box} name='padding'/>
          </Box>
        )
      },
    }];

    return [{
      label: Bs4I18N.getTT('Form-section', 'Form-section', 'Bs4Form'),
      getUxTemplate: () => this.uxTemplate,
      setUxTemplate: this.setUxTemplate,
      types: [TYPE_BS4_FORM],
      Content: (props) => {
        const [expanded, setExpanded] = React.useState(eds[0].label);        
        const handleChange = (panel) => (event, isExpanded) => {
          // console.log('... UxAccordion .Main. .handleChange.', panel, isExpanded)
          setExpanded(isExpanded ? panel : false);
        };

        return (
          <React.Fragment>
            {eds.map((ux, index) => {
              return (
                <UxAccordion 
                  key={index} 
                  label={ux.label} 
                  types={ux.types}
                  expanded={expanded} 
                  onChange={handleChange} 
                  onReset={ux.onReset}
                >
                  <ux.Content />
                </UxAccordion>
              )
            })}
          </React.Fragment>
        )
      },
    }]
  }  

  // lastPointerCoordinates = {x: 0, y: 0};
  // lastCollisionDetectionArray = [];

  customCollisionDetectionAlgorithm = (props) => {
    const {active, droppableContainers, droppableRects, ...args} = props;    

    if (!active.data.current.formElement) {
      // console.log('...???...CollisionDetection...return...', active.data.current.formElement, active);
      return null;
    }

    if (active.data.current.type === 'file') {
      return this.customCollisionDetectionAlgorithmFile(props);
    }
    
    active.data.current.formElement.inList = false;
    active.data.current.formElement.inDelete = false;
    const collisionDetectionArray = [];

    // const dx = (props.pointerCoordinates?.x || 0) - (this.lastPointerCoordinates.x || 0);
    // const dy = (props.pointerCoordinates?.y || 0) - (this.lastPointerCoordinates.y || 0);
    // const v = Math.sqrt((dx * dx) + (dy * dy));     

    // this.lastPointerCoordinates = props.pointerCoordinates;
    // this.lastFormElementType = active.data.current.formElement.formElementType;

    for (const droppableContainer of droppableContainers) {      
      if (active.data.current.formElement.formElementType > droppableContainer.data.current.formElement.formElementType) continue;
      if (droppableContainer.data.current.formElement.formElementType < 900) {
        if (droppableContainer.data.current.formElement.formElementType - active.data.current.formElement.formElementType > 1) continue;      
        //2025-02-02      
        if (droppableContainer.data.current.formElement.formElementType > active.data.current.formElement.formElementType) {
          if (droppableContainer.data.current.formElement.formElementArray.length > 1) continue;
          if (droppableContainer.data.current.formElement.formElementArray.length === 1) {
            const child = droppableContainer.data.current.formElement.formElementArray[0];            
            if (child.original !== active.data.current.formElement) continue;
          } 
        }
      }

      const {id} = droppableContainer;
      const rect = droppableContainer?.node?.current?.getBoundingClientRect();
      if (!rect) continue;      

      const isInX = rect.left < props.pointerCoordinates.x && rect.right > props.pointerCoordinates.x;
      const isInY = rect.top < props.pointerCoordinates.y && rect.bottom > props.pointerCoordinates.y;

      const left = Math.abs(rect.left - props.pointerCoordinates.x);
      const right = Math.abs(props.pointerCoordinates.x - rect.right);
      const top = Math.abs(rect.top - props.pointerCoordinates.y);
      const bottom = Math.abs(props.pointerCoordinates.y - rect.bottom);      

      let rectangularDistance = 0;
      if (isInX && isInY) rectangularDistance = 0;
      else if (isInX) rectangularDistance = Math.min(top, bottom);
      else if (isInY) rectangularDistance = Math.min(left, right);
      else rectangularDistance = Math.max(Math.min(left, right), Math.min(top, bottom));    

      let before = false;
      if (isInX && isInY) before = left < right;
      else if (isInY) before = left < right; 
      else before = top < bottom; 

      if (droppableContainer.data.current.formElement.formElementType === 999 && isInX && isInY) {        
        active.data.current.formElement.inList = true;
      }

      if (droppableContainer.data.current.formElement.formElementType === 998 && isInX && isInY) {        
        active.data.current.formElement.inDelete = true;
      }
  
      droppableContainer.data.current.formElement.colisionBefore = before;
      collisionDetectionArray.push({id, data: {droppableContainer, value: droppableContainer.data.current.formElement.formElementType, value1: rectangularDistance}})
    }    

    const sortCollisionsAsc = ({data: {value: valueA, value1: value1A}}, {data: {value: valueB, value1: value1B}}) => {      
      return value1A - value1B;
    };

    this.lastCollisionDetectionArray = collisionDetectionArray.sort(sortCollisionsAsc);
    return this.lastCollisionDetectionArray;
  };

  customCollisionDetectionAlgorithmFile = (props) => {
    const {active, droppableContainers, droppableRects, ...args} = props;
    
    if (!active.data.current.formElement || active.data.current.type !== 'file') return null;
    
    const collisionDetectionArray = [];    

    for (const droppableContainer of droppableContainers) {            
      if (droppableContainer.data.current.type !== 'file') continue;            
      if (droppableContainer.data.current.formElement === active.data.current.formElement) continue;     
      const {id} = droppableContainer;
      const rect = droppableContainer?.node?.current?.getBoundingClientRect();
      if (rect) {
        if (rect.left > props.pointerCoordinates.x) continue;
        if (rect.right < props.pointerCoordinates.x) continue;
        if (rect.top > props.pointerCoordinates.y) continue;
        if (rect.bottom < props.pointerCoordinates.y) continue;
        collisionDetectionArray.push({id, data: {droppableContainer, value: droppableContainer.data.current.formElement.formElementType}})
        return collisionDetectionArray;
      }
    }
    
    return null;
  };

  getFormPartitions() {
    const bs4Kartoteka = Bs4Kartoteka.get(this.bs4KartotekaId);
    let pola = bs4Kartoteka.message?._Komunikat?.pola || [];
    let formPartitions = pola[this.optionId] || {};
    if (!Array.isArray(formPartitions)) formPartitions = [formPartitions];
    return formPartitions;
  }   

  getFormSections(sections) {  
    if (!sections) sections = [];
    if (!Array.isArray(sections)) sections = [sections];
    return sections;
  }
  
  getFormFields (fields) {
    if (!fields) fields = [];
    if (!Array.isArray(fields)) fields = [fields];
    if (fields.length === 0 && false) {
      fields = [{
        fieldLabel: this.etykieta,
        formId: null,
        inputId: uuidv4(),
        //wherePutLabel: "u",
        //width: 0,
        xtype: "bs4GenericField",
      }];
    }

    return fields;
  }

  createForm() {        
    this.setUxTemplate()
    this.createFormElements();
    this.dragDropSection = this.getPageParam('dragDropSection');
  }

  getFormProps = () => {
    return {bs4KartotekaId: this.bs4KartotekaId, optionId: this.optionId, criterion: this.criterion, bs4ConstructorMode: this.bs4ConstructorMode};
  }

  createFormElements() {        
    const formProps = this.getFormProps();
    this.formElementArray = [];
    this.getFormPartitions().map((partition) => {
      partition.inputId =  'elme_partition_'+(partition.formId || uuidv4());
      const bs4Partition = new Bs4Partition({
        ...formProps, 
        formId: partition.formId, 
        inputId: partition.inputId, 
        partition: partition,
      });
      bs4Partition.bs4Form = this;
      this.formElementArray.push(bs4Partition);

      this.getFormSections(partition.section).forEach(section => {
        if (!section) return;
        section.inputId = section.inputId || uuidv4();
        const bs4Section = new Bs4Section({
          ...formProps, 
          formId: section.formId,
          inputId: section.inputId,
          section: section, 
        })
        bs4Section.bs4Form = this;
        bs4Partition.formElementArray.push(bs4Section);
        this.setFormElement(bs4Section);
        if (section.bs4flexframe) {
          bs4Partition.bs4flexframe = true;
          this.bs4flexframe = true;
        }
        
        
        this.getFormFields(section.fields).map((field) => {
          field.inputId = field.inputId || uuidv4();
          const bs4Field = formFieldBinding({
            ...formProps, 
            formId: field.formId,
            inputId: field.inputId, 
            field: field, 
            bs4flexframe: Boolean(section.bs4flexframe)
          });
          bs4Field.bs4Form = this;
          bs4Field.initializeFormField();          
          bs4Section.formElementArray.push(bs4Field);
          this.setFormElement(bs4Field);
        });
      });
    });    
  }

  formFieldsRefresh = (message) => {
    const optionId = message?._Komunikat?.optionId;
    const pola = message?._Komunikat?.pola[optionId];
    const editedInputIds = message?._Komunikat?.editedInputIds;

    const ok = this.formElementsCheckIfTheyAreTheSame(pola, editedInputIds);
    if (ok) return;
    // 4('...formFieldsRefresh. not ok');
    const bs4Kartoteka = Bs4Kartoteka.get(this.bs4KartotekaId);
    bs4Kartoteka.message._Komunikat.pola[this.optionId] = pola;
    this.createFormElements();
    this.setUpdate();
  }

  formElementsCheckIfTheyAreTheSame = (partitions, editedInputIds) => {

    if (!Array.isArray(partitions)) partitions = [partitions];

    if (partitions.length !== this.formElementArray.length) {
      console.log('... refreshForm... partition new.length !== old.lenght', partitions, this.formElementArray);
      return false;
    }

    for (let ip = 0; ip < partitions.length; ip++) {
      const partition = partitions[ip];
      let bs4Partition = this.formElementArray[ip];
      if (bs4Partition instanceof Bs4FormElementDraggable) {
        if (editedInputIds?.includes(partition.inputId)) {
          const formProps = this.getFormProps();
          bs4Partition = new Bs4Partition({
            ...formProps, 
            formId: partition.formId, 
            inputId: partition.inputId, 
            partition: partition,
          });
          this.formElementArray[ip] = bs4Partition;
          this.setFormElement(bs4Partition);
          this.setUpdate();
        } else {
          this.removeFormElement(bs4Partition);
            this.setUpdate();
            return false;
        }
      }
      
      if (partition.inputId !== bs4Partition.inputId) {
        // console.log('...refreshForm.s. partition !== ', ip, partition, bs4Partition);
        return false;
      }

      if (partition?.section?.length !== bs4Partition?.formElementArray?.length) {
        // console.log('...refreshForm... section new.length !== old.lenght', partition, bs4Partition);
        return false;
      }      
      
      for (let is = 0; is < partition.section.length; is++) {
        const section = partition.section[is];
        let bs4Section = bs4Partition.formElementArray[is];

        if (bs4Section instanceof Bs4FormElementDraggable) {
          if (editedInputIds?.includes(section.inputId)) {
            // console.log('...refreshForm.s. Bs4FormElementDraggable');
            const formProps = this.getFormProps();
            bs4Section = new Bs4Section({
              ...formProps, 
              formId: section.formId,
              inputId: section.inputId,
              section: section, 
              bs4Form: this,
            })
            bs4Partition.formElementArray[is] = bs4Section;
            this.setFormElement(bs4Section);
            this.setUpdate();
          } else {
            // console.log('...refreshForm.new item has not been added...', bs4Section)
            this.removeFormElement(bs4Section);
            this.setUpdate();
            return false;
          }
        }
        if (section.inputId !== bs4Section.inputId) {
          // console.log('...refreshForm.s. section !== ', is, {...section}, {...bs4Section});
          return false;
        }

        if (section?.fields?.length !== bs4Section?.formElementArray?.length) {
          // console.log('...refreshForm...section !=', section, bs4Section);
          return false;
        }

        for (let ii = 0; ii < section.fields.length; ii++) {
          const field = section.fields[ii];
          let bs4Field = bs4Section.formElementArray[ii];
          
          if (bs4Field instanceof Bs4FormElementDraggable) {
            if (editedInputIds?.includes(field.inputId)) {
              // console.log('...refreshForm.s. Bs4FormElementDraggable');
              const formProps = this.getFormProps();
              bs4Field = formFieldBinding({
                ...formProps, 
                formId: field.formId,
                inputId: field.inputId, 
                field: field, 
                bs4flexframe: Boolean(section.bs4flexframe)
              });
              bs4Field.bs4Form = this;
              bs4Field.initializeFormField();              
              bs4Section.formElementArray[ii] = bs4Field;
              this.setFormElement(bs4Field);
              this.setUpdate();
            } else {
              // console.log('...refreshForm.new item has not been added...', bs4Field)
              this.removeFormElement(bs4Field);
              this.setUpdate();
              return false;
            }
          }
          if (field.inputId !== bs4Field.inputId) {
            // console.log('...refreshForm.s. field !== ', is, {...field}, {...bs4Field});
            return false;
          }
        }
      }
    }
    
    return true;
  }
  
  removeFormElement = (parent, formElement) => {
    for (let i = 0; i < parent.formElementArray.length; i++) {
      const child = parent.formElementArray[i];
      if (child === formElement) {
        return parent.formElementArray.splice(i, 1)[0];
      }

      if (child.formElementArray) {
        const removed = this.removeFormElement(child, formElement);
        if (removed) return removed;
      }
    }

    return null;
  }
  
  getFormElementLocation = (parent, formElement, after) => {

    if (parent.formElementType <= formElement.formElementType) {
      return null;
    }
    for (let index = 0; index < parent.formElementArray.length; index++) {
      const child = parent.formElementArray[index];
      if (child === formElement) {
        return {after, parent, index}
      }
      after = child
      if (child.formElementArray) {
        const location = this.getFormElementLocation(child, formElement, after);
        if (location) return location;
      }
    }

    return null;
  }

  moveFormElement = (event, activeFormElement) => {    
    const active = event.active.data.current.formElement;
    const add = event.active.data.current.add;
    let over = event.over.data.current.formElement;

    if (active.formElementType - over.formElementType > 1) {
      // Pominięty kontener (np. pole w partycji (szpalcie)). Raczej niemożliwe!
      // console.log('...moveFormElement...aType - oType > 1', event);
      return null;
    }

    if (over.formElementType - active.formElementType === 1) {
      if (over.formElementArray.length > 0) {
        // Element rodzic musi być pusty. W przeciwnym razie 'drop' powinien nastąpić w relacji do dziecka rodzica.
        if (over.formElementArray.length > 1) return null;
        // 2025-01-01 Element rodzic, który zawiera 1 element === actiwe, jest uznawany za pusty.
        if (over.formElementArray[0].original !== active) return null;
        // console.log('...moveFormElement...length > 0', active, over.formElementArray[0]);        
      }
      this.removeFormElement(this, activeFormElement);    
      over.formElementArray.push(activeFormElement);
      this.lastMove = {activeFormElement, after: over, add: add};
      return this.lastMove;
    }

    if (active.formElementType !== over.formElementType) {
      // Elementy muszą być tego samego typu (pole - pole, sekcja - sekcja, itp). Raczej zawsze spełnione!
      // console.log('...???...moveFormElement...aType !== oType', event);
      return null;      
    }
    
    this.removeFormElement(this, activeFormElement);    

    const location = this.getFormElementLocation(this, over, this);
    if (!location) {
      // Teoretycznie niemożliwe!
      // console.log('...???...moveFormElement...location === null', event, over);
      return null;
    }

    location.parent.formElementArray.splice(location.index + (over.colisionBefore ? 0 : 1), 0, activeFormElement);
    this.lastMove = {activeFormElement, after: over.colisionBefore ? location.after : over, add: add};

    return this.lastMove;    
  }

  /*
    Zgodnie z rozmową tel.
    Po przeciągnięciu nowego (dodawaniu) lub istniejącego elementu proszę o wywoływanie do serwera requestu: bs4SaveFormEditor
    Akcja na serwerze dodana na ml3 ale jeszcze nic nie zapisuje. Niemniej zwraca nowy rodzaj dymku: FORM_FIELDS_REFRESH - który docelowo ma mieć tylko 'pola' bez nadmiarowych danyc - w celu odświeżenia struktury formularza.
    Parametry na wejsciu do requesta:
        // operation - add/move - czy dodajemy nowy z lewej szpalty czy przeciągamy istniejący (move)
        // dropAfterFormId - za elementem o jakim ID upuszczamy
        // formElementType - id rodzaju elementu jaki upuszczamy jeśli (add) nowy element z lewej szpalty
        // currFormId - id istniejącego elementu, który przeciągamy jeśli move
        // currOptionId - id bieżącej strony jak zwykle
        // additionalForm - dane z mini formularza, który był w lewej szpalcie

    Ponadto dla stron typu formularz, gdy je wczytujemy w trybie konstruktor, serwer dostarcza dodatkową tablicę danych ''dragDropSection" (podobnie jak dla edytora triggerów), która zawiera do lewej szpalty (rozwijanej opcjonalnie plusikiem) listę elementów możliwych do dodania a także dane do mini formularza (testowe pola na razie ale struktura danych docelowa)
  */

  executeMove = () => {      
    if (!this.lastMove) return;        
    const detailsaftermove = {};
    if (this.lastMove.add) {
      detailsaftermove.operation = 'add';
      detailsaftermove.formElementType = this.lastMove.activeFormElement.id;
      this.lastMove.activeFormElement.original.setDraggableId();
    } else {
      detailsaftermove.operation = 'move';
      detailsaftermove.currFormId = this.lastMove.activeFormElement.formId || 0;
    }
    detailsaftermove.dropAfterFormId = this.lastMove.after.formId || 0;
    // console.log('...executeMove...', this.lastMove, detailsaftermove)
    Bs4MainDispatch.commandParser('bs4SaveFormEditor', detailsaftermove, this.bs4KartotekaId);
    this.lastMove = null;
  }

  executeDelete = (formElement) => {      
    const detailsaftermove = {
      operation: 'delete',
      currFormId: formElement.formId || 0,
    };    
    // console.log('...executeDelete...', detailsaftermove, formElement)
    Bs4MainDispatch.commandParser('bs4SaveFormEditor', detailsaftermove, this.bs4KartotekaId);
    this.lastMove = null;
  }


  getFormElement(inputId) {
    return this.bs4InputIdMap.get(inputId);
  }

  setFormElement(input) {
    // 2023-08-30 Zdarza się puste 'inputId' (undefined). Zakładam, że taki element nie będzie potrzebny. (?!?)
    if (input.inputId) this.bs4InputIdMap.set(input.inputId, input);
  }

  deleteFormElement(input) {
    // 2023-08-30 Zdarza się puste 'inputId' (undefined). Zakładam, że taki element nie będzie potrzebny. (?!?)
    if (input.inputId) return this.bs4InputIdMap.delete(input.inputId);
  }

  getFields() {    
    return Array.from(this.bs4InputIdMap.values()).filter(input => input instanceof Bs4GenericField);
  }
  
  getDetails = (formId) => {
    const fields = this.gatherFormValues(); 
		const details = { 
			currFormId: formId, 
			formData: fields.fieldsDict,
			formDataOriginal: fields.fieldsDictOriginal 
		};
    return details;
  }

  stopAtrybOnchange = false;

  setStopAtrybOnchange = (stop) => {
    this.stopAtrybOnchange = stop;
  }

  atrybOnchange (formId, cmd, bs4selected, callbackLoad, autoclick) {
    if (this.stopAtrybOnchange) return;
		const fields = this.gatherFormValues(); 
		const details = this.getDetails(formId);
		if (bs4selected) details.bs4selected = bs4selected;
    if (autoclick) details.autoclick = 1;
    // console.log('== Bs4Form atrybOnchange ==', formId, cmd, bs4selected, details, autoclick);
		Bs4MainDispatch.commandParser(cmd, details, this.bs4KartotekaId, callbackLoad);    
	}

  gatherFormValues = () => {
    const fieldsDict = {};
    this.getFields().forEach((input, key) => {
      if (input.hesValue() && input.displayElementDom !== 'none') {
        fieldsDict[input.inputId] = input.getValueBs4();        
      }
    });        
    return {fieldsDict: fieldsDict}
  }

  gatherCriteriaValues = () => { 
    const criteriaValues = {};
    this.getFields().forEach(input => {
      if (input.hesValue() && input.isSelected() && input.displayElementDom !== 'none') {
        criteriaValues[input.inputId] = input.getValueBs4();
      }
    });
    // console.log('...gatherCriteriaValues...', criteriaValues)
    return criteriaValues;
  }

  clear() {
    this.getFields().forEach(field => field.clear())
  }

  getDirty() {    
    const dirty = [];
    return this.getFields().filter(field => field.isDirty())
  }

  isDirty() {    
    return this.getDirty().length > 0;
  }

  saveState() {
    return this.getFields().forEach(field => {
      field.savedValue = field.getValue();
      field.savedSelected = field.isSelected();
    })
  }

  restoreState() {
    return this.getFields().forEach(field => {
      field.setValue(field.savedValue);
      field.setSelected(field.savedSelected);
    })
  }

  ViewDragOverlay = (props) => {
    const {activeCurrent} = React.useContext(this.activeCurrentContext);
    // console.log('...Bs4Form...ViewDragOverlay...', props, props.activeCurrent?.type)
    if (props.activeCurrent?.formElement?.ViewFileItem && props.activeCurrent?.type === 'file') {
      return (
        <props.activeCurrent.formElement.ViewFileItem {...props.activeCurrent.props} over={true}/>
      )
    }

    if (!activeCurrent?.formElement) return null;
    
    const size = activeCurrent.formElement.getFormElementSize();
    return <activeCurrent.formElement.ViewComponent size={size}/>
  }

  formElementType = 4;

  activeCurrentContext = React.createContext({});
 
  ViewComponentFormDroppable = (props) => {
    const form = this;
    const setScrollTarget = useScrollTarget(this.optionId, this.criterion);
    const {isOver, setNodeRef, node} = useDroppable({
      id: this.getElementId('Droppable'),
      data: {
        formElement: this,
        type: 'form',
      },
      disabled: !this.bs4ConstructorMode.enabled,
    });

    return (
      <form.ViewComponentForm {...props} setNodeRef={setNodeRef} setScrollTarget={setScrollTarget}/>
    )
  };

  ViewComponentForm = React.memo((props) => {
    const form = this;
    const length = this.formElementArray.length;
    

    const refSpeedTest = React.useRef({
      shallowEqualValues: null,
      shallowEqualProps: null,
    });    

    Bs4MainDispatch.speedRun((tag) => {
      const newObj = {  
        length,
      };
      console.log(Bs4MainDispatch.speedNextTime(tag), Bs4MainDispatch.speedBs4KarOpt(this.bs4KartotekaId, this.optionId), Bs4Utils.shallowEqual(newObj, refSpeedTest.current.shallowEqualValues, Bs4MainDispatch.speedPrefix+tag+' EqualValues'), Bs4Utils.shallowEqual(props, refSpeedTest.current.shallowEqualProps, Bs4MainDispatch.speedPrefix+tag+' EqualProps'));
      refSpeedTest.current.shallowEqualValues = newObj;
      refSpeedTest.current.shallowEqualProps = props;
    }, '..Form..');

    return (
      <Box
        id={form.getElementId('Box_partitions')}
        ref={node => {
          props.setNodeRef(node); 
          if (props.setScrollTarget) props.setScrollTarget(node);
        }}
        height='100%'
        flex={1}
        overflow={form.bs4flexframe ? 'hidden' : 'auto'}
        display='flex'
        flexWrap={form.bs4flexframe ? 'nowrap' : 'wrap'}
        flexDirection='row'        
      >
        {this.formElementArray.map((partition, index) => (
          <partition.ViewComponent key={partition.inputId} partitionStart={index === 0} partitionEnd={index === length - 1} {...props}/>)
        )}
      </Box>        
    );
  });

  closeBs4Form = () => {
    this.eventEmit.trigger(Bs4GenericField.CLOSE_BS4_FORM, Bs4GenericField.CLOSE_BS4_FORM);
  }

  canShowTooltip = (object, id) => {
    if (object.isEqualId(id) && object.displayElementDom !== 'none') return true;
    if (!Array.isArray(object.formElementArray)) return false;
    return Boolean(object.formElementArray.find(formElement => this.canShowTooltip(formElement, id)));
  }

  showTooltip = null;
  showTooltipWait = null;
  setShowTooltip = (id, showTooltip, closeTooltip) => {
    this.showTooltipWait = [id, showTooltip, closeTooltip];
  }

  ViewComponent = React.forwardRef((props, ref) => {
    const form = this;
    const [activeCurrent, setActiveCurrent] = React.useState(null)
    const [update, setUpdate] = React.useState(0)
    const [addNew, setAddNew] = React.useState(false);
    const [showTooltip, setShowTooltip] = React.useState(null);

    const droppable = useDroppable({
      id: this.getElementId('Droppable'),
      data: {
        formElement: this,
        type: 'form',
      },
      disabled: !this.bs4ConstructorMode.enabled,
    });

    const {setNodeRefDroppable} = React.useMemo(() => {
      return { isOver: droppable.isOver, setNodeRefDroppable: droppable.setNodeRef, node: droppable.node }
    }, [droppable])
     
    React.useEffect(() => {
      this.setUpdate = () => setUpdate(update + 1);
      this.setAddNew = setAddNew;      
    }, [update, setUpdate, setAddNew])

    React.useEffect(() => {
      // To jest bardzo Ok OK OK ! ! !
      if (this.closeCriteria && this.showTooltip && showTooltip === null) this.closeCriteria(null);
      this.showTooltip = showTooltip;

      this.setShowTooltip = (id, showTooltip, closeTooltip) => {
        if (this.openCriteria) this.openCriteria();  
        setShowTooltip({
          id, 
          showTooltip,           
          closeTooltip,
          setShowTooltip, 
        });          
      }
      if (this.showTooltipWait) this.setShowTooltip(...this.showTooltipWait);
      this.showTooltipWait = null;                      
    }, [showTooltip, setShowTooltip])

    const handleDragStart = (event) => {      
      console.log('...DragStart...', event.over ,event);
      this.lastMove = null;
      if (!event.active) return;
      let activeCurrent = event.active.data.current;    

      if (activeCurrent.type === 'form') {
        if (activeCurrent.add) {
          const newFormElement = new Bs4FormElementDraggable(activeCurrent.formElement.element)
          newFormElement.bs4Form = this;
          newFormElement.original = activeCurrent.formElement;
          activeCurrent.formElement = newFormElement;
        }
        activeCurrent.location = this.getFormElementLocation(this, activeCurrent.formElement, this);
        // console.log('...DragStart...location', activeCurrent.location);
      }
      
      setActiveCurrent(activeCurrent);
    }    

    const handleDragMove = (event) => {
      // console.log('...DragMove...', event.over?.data?.current?.formElement?.formElementType, event.over ,event);

      if (!event.over) {
        // console.log('...DragMove.No.over', event);
        return;
      }

      if (event.over?.data?.current?.formElement === activeCurrent.formElement) {
        // console.log('...DragMove.No...same', event);
        return;
      }                  
      
      if (activeCurrent.type === 'file') {
        return;
      }

      if (event.active.data.current.formElement.inList) {
        // console.log('...DragMove.999.1.', event.active);
        if (event.active.data.current.add) {
          this.removeFormElement(this, activeCurrent.formElement);           
          this.lastMove = null;
          setUpdate(update + 1);
          return;
        }
      }

      if (this.moveFormElement(event, activeCurrent.formElement)) {         
        //if (event?.over?.data?.current?.formElement?.setHiddenElement) event.over.data.current.formElement.setHiddenElement(null)
        setUpdate(update + 1);
        //console.log('...moveFormElement...MOVE', event, this.lastMove);
      }
    }
    
    const handleDragEnd = (event) => {      
      // console.log('...DragEnd...', this.lastMove);
      setActiveCurrent(null);
      if (activeCurrent.type === 'file') {             
        const bs4FileAciveCurrent = event.active?.data?.current;
        const bs4FileOverCurrent = event.over?.data?.current;
        if (!bs4FileAciveCurrent?.formElement?.fileDragCut) return;
        if (!bs4FileAciveCurrent?.props?.item) return;
        if (!bs4FileOverCurrent?.formElement?.fileDragPaste) return;        
        bs4FileAciveCurrent.formElement.fileDragCut(bs4FileAciveCurrent.props.item);
        bs4FileOverCurrent.formElement.fileDragPaste(bs4FileAciveCurrent.props.item);        
        return;
      }

      if (event.active.data.current.formElement.inDelete) {
        // console.log('...DragEnd.998.1.', event.active);
        if (!event.active.data.current.add) {
          this.removeFormElement(this, activeCurrent.formElement);          
          this.lastMove = null;
          this.executeDelete(activeCurrent.formElement);
          setUpdate(update + 1);
          return;
        }
      }

      this.executeMove();      
    }

    const handleDragCancel = (event) => {
      if (activeCurrent.type === 'form') {
        const element = this.removeFormElement(this, activeCurrent.formElement);
        if (activeCurrent.location) {
          activeCurrent.location.parent.formElementArray.splice(activeCurrent.location.index, 0, element);
        }        
      }      
      setActiveCurrent(null);      
    }    

    return (
      <DndContext
        onDragStart={handleDragStart}
        onDragEnd={handleDragEnd}
        onDragMove={handleDragMove}
        onDragCancel={handleDragCancel}
        //collisionDetection={closestCenter}
        collisionDetection={form.customCollisionDetectionAlgorithm}
        //sensors={sensors}
      >
        <form.activeCurrentContext.Provider value={{activeCurrent: activeCurrent}}>
          <Box 
            ref={node => {
              if (ref) ref.current = node;
              setNodeRefDroppable(node)
            }}
            id={form.getElementId()}
            height='100%'
            width='100%'
            overflow='hidden'
            display='flex'
            flexDirection='row'            
          >
            <Bs4FormElementDraggableList dragDropSection={form.dragDropSection} addNew={addNew} onClose={() => setAddNew(false)} bs4Form={this}/>
            <form.ViewComponentFormDroppable 
              {...props} 
              showTooltip={showTooltip} 
              update={update}
            />
          </Box>        
          <DragOverlay> 
            <form.ViewDragOverlay activeCurrent={activeCurrent}/>
          </DragOverlay>
        </form.activeCurrentContext.Provider>
      </DndContext>
    );
  });
}